export default "__VITE_ASSET__jOkYnwm9__"